import React from "react";
import { connect } from "react-redux";
import VendorContent from "containers/request/RequestContent/VendorContent";
import reqTypes from "dictionaries/ReqTypes";
import { batteryTabsARR, batteryTabsARRECO } from "helpers/RequestTabsHelper";
import {
  getChecklistInitialARR,
  getChecklistEcoARR,
} from "helpers/ChecklistBatteryHelper";

const RequestContentARR = ({ request, focusLab }) => {
  const checkListInitial = getChecklistInitialARR(request);
  const checkListECO = getChecklistEcoARR(request);

  switch (request.type) {
    case reqTypes.initial:
      return (
        <VendorContent
          tabs={batteryTabsARR}
          checkList={checkListInitial}
          defaultTab={focusLab ? "labInfo" : "deviceInfo"}
        />
      );
    case reqTypes.eco:
      return (
        <VendorContent
          tabs={batteryTabsARRECO}
          checkList={checkListECO}
          defaultTab={focusLab ? "labInfo" : "deviceInfo"}
        />
      );
    default:
      return null;
  }
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(RequestContentARR);
